"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPresenceStatus = void 0;
var UserPresenceStatus;
(function (UserPresenceStatus) {
    UserPresenceStatus[UserPresenceStatus["lurking"] = 0] = "lurking";
    UserPresenceStatus[UserPresenceStatus["engaging"] = 1] = "engaging";
})(UserPresenceStatus || (exports.UserPresenceStatus = UserPresenceStatus = {}));
//# sourceMappingURL=presence.js.map